import {
  TableContainer,
  Table,
  TableHeader,
  TableBody,
  TableRow,
  TableCell,
  TableFooter,
  Pagination,
} from "@windmill/react-ui";
import React, { useEffect } from "react";
import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { SipUsers } from "../../api/Actions/ServicePhone";
import { AllOrganizationUsers } from "../../api/Actions/SsoB3/SsoB3";

export default function UserList() {
  const dispatch = useDispatch();
  const [UsersData, setUsersData] = useState(false);
  const [Provision, setProvision] = useState(false);
  const arrayOfUsersData = [];
  const [LoadingData, setLoadingData] = useState(true);
  const [DisableRefresh, setDisableRefresh] = useState(false);
  const [Page, setPage] = useState("1");

  const OrgUsers = useSelector((state) => state.UsersLogin.OrgUsers);
  const SipUsersData = useSelector((state) => state.SipUsers.GetAllSipUsers);

  const HandlePagination = (selectedPage) => {
    if (!selectedPage || selectedPage !== OrgUsers.data.users.page) {
      setLoadingData(true);
      // handle userlist pagination
      const paramOrg = {
        limit: 10,
        page: Number(selectedPage) || OrgUsers.data.users.page,
      };
      dispatch(AllOrganizationUsers(localStorage.getItem("orgUuid"), paramOrg));
    }
  };

  const HandleRefresh = () => {
    setDisableRefresh(true);
    // HandlePagination();
    setProvision(true);
    const paramOrg = {
      limit: 10,
      page: Number(Page),
    };
    dispatch(AllOrganizationUsers(localStorage.getItem("orgUuid"), paramOrg));
  };

  useEffect(() => {
    const paramOrg = {
      limit: 10,
      page: Number(Page),
    };
    dispatch(AllOrganizationUsers(localStorage.getItem("orgUuid"), paramOrg));
  }, []);

  useEffect(() => {
    setLoadingData(false);
    setDisableRefresh(false);
  }, [OrgUsers]);

  return (
    <div className="flex flex-col mt-4 shadow-inner bg-slate-100 rounded-xl h-full w-full overflow-y-auto">
      {/* <div className="flex flex-row m-4 justify-end text-xs">
        <button
          onClick={() => HandleRefresh()}
          className="bg-main-blue text-white py-3 px-4 rounded-md my-2 mx-6 sm:mx-2 poppins-500 active:bg-blue-800"
        >
          Provision
        </button>
      </div>
      
      {Provision ? ( */}
      <div className="flex flex-col w-full h-full">
        <TableContainer className="border-2 w-full overflow-y-auto">
          <Table>
            <TableHeader>
              <TableRow className="">
                <TableCell className="content-center poppins-800">
                  EMAIL
                </TableCell>
                <TableCell className="content-center poppins-800">
                  NAME
                </TableCell>
                <TableCell className="content-center poppins-800">
                  EXT
                </TableCell>
              </TableRow>
            </TableHeader>
            {!LoadingData ? (
              <>
                {OrgUsers.data && OrgUsers.data.users.count > 0 ? (
                  <TableBody>
                    {OrgUsers.data.users.rows.map((element, id) => {
                      return (
                        <TableRow key={id}>
                          <TableCell>{element.email}</TableCell>
                          <TableCell>{element.name}</TableCell>
                          <TableCell>{element.ext}</TableCell>
                        </TableRow>
                      );
                    })}
                  </TableBody>
                ) : OrgUsers.data && OrgUsers.data.users.count < 1 ? (
                  <TableBody>
                    <TableRow className="bg-white dark:bg-cool-gray-800 text-center">
                      <TableCell colSpan={3}>
                        <h1 className="mx-auto">Data Not Found</h1>
                      </TableCell>
                    </TableRow>
                  </TableBody>
                ) : (
                  <TableBody>
                    <TableRow className="bg-white dark:bg-cool-gray-800 text-center">
                      <TableCell colSpan={3}>
                        <h1 className="mx-auto">Loading Data</h1>
                      </TableCell>
                    </TableRow>
                  </TableBody>
                )}
              </>
            ) : (
              <TableBody>
                <TableRow className="bg-white dark:bg-cool-gray-800 text-center">
                  <TableCell colSpan={3}>
                    <h1 className="mx-auto">Loading Data</h1>
                  </TableCell>
                </TableRow>
              </TableBody>
            )}
          </Table>
          {OrgUsers.data && OrgUsers.data.users.count > 0 ? (
            <TableFooter>
              <Pagination
                totalResults={OrgUsers.data.users.count}
                resultsPerPage={10}
                onChange={(e) => HandlePagination(e)}
                label="Page navigation"
              />
            </TableFooter>
          ) : (
            <TableFooter></TableFooter>
          )}
        </TableContainer>
      </div>
      {/* ) : (
        ""
      )} */}
    </div>
  );
}
